<template>
  <div class="column upload-card">
    <img
      class="row center--img"
      src="/assets/images/sources/folder-cancel-outline.png"
    />
    <label class="message-drag message-title">
      <b>{{
        $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.FILE_TYPE_INVALID.TITLE')
      }}</b>
    </label>
    <label class="row column message-drag">
      {{
        $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.FILE_TYPE_INVALID.DESC')
      }}
    </label>
    <label class="row column message-drag file-name">
      {{ $t('DOCUMENT_SOURCES.FILE_NAME') }}:
      <b>
        <u>{{ fileName(file) }}</u>
      </b>
    </label>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { getFileName } from 'helpers/FileHelper';

export default {
  mixins: [alertMixin],
  props: {
    file: {
      type: [Object, File],
    },
    url: {
      type: String,
      default: '',
    },
  },
  methods: {
    fileName(name) {
      return getFileName(name);
    },
  },
};
</script>
<style scoped lang="scss">
.upload-card {
  margin: 0 0 1.6rem;
  padding: var(--space-large);
  border: 1px solid var(--s-75);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--s-25);
  height: var(--space-giga);
}

.center--img {
  margin: auto;
  height: var(--space-jumbo);
}
.message-drag {
  color: var(--w-500);
  text-align: center;
}
.message-title {
  font-size: var(--font-size-medium);
}
.file-name {
  margin-top: var(--space-normal);
}
</style>
